import { Text } from '@chakra-ui/react';

import { RegistryPackage } from '@/graphql/upbound-graphql';
import ChevronIcon from '@/icons/ChevronIcon';

const PackageListBreadcrumbs: React.FC<{ data: RegistryPackage }> = ({ data }) => {
  return (
    <>
      <ChevronIcon direction="right" size="lg" color="white.5" width="16px" height="16px" mr="6px" ml="6px" />
      <Text as="span" color="grey.1" fontSize="14px" lineHeight="40px">
        {data.displayName}
      </Text>
    </>
  );
};

export default PackageListBreadcrumbs;
